import React, { useEffect, useRef, useState } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

//import BackNavbar from "../src/components/navbar/BackNavbar";
import CompareMenu from '../src/components/compareMenu/CompareMenu';
import CookieConsent from './components/cookies/CookieConsent';
import Layout from './components/layout/Layout';
import MetaTags from './components/meta/MetaTags';

function App() {
  const location = useLocation();
  const [gaReady, setGaReady] = useState(false);
  const gaInitStarted = useRef(false);

  // Defer GA init to idle time — reduces main-thread contention during first paint (homepage).
  useEffect(() => {
    if (gaInitStarted.current) return;
    gaInitStarted.current = true;

    const init = () => {
      ReactGA.initialize(process.env.REACT_APP_GA_ID || 'G-NXE1XLG75C');
      setGaReady(true);
    };

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      const id = window.requestIdleCallback(init, { timeout: 2500 });
      return () => window.cancelIdleCallback(id);
    }
    const t = window.setTimeout(init, 0);
    return () => window.clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!gaReady) return;
    ReactGA.pageview(location.pathname + location.search);
  }, [location, gaReady]);

  return (
    <div className="App">
      <MetaTags
        title="Homepage - GolfLists.com"
        description="Golflists.com is a huge database of local golf insights made for golf travelers, historians, nerds, tickers etc."
        imageUrl="https://stjbqlfgvlefqghlyumg.supabase.co/storage/v1/object/public/brand/GL_LOGO_300_302.png"
        url="https://golflists.com"
        keywords="GolfLists, About, Ambassador"
      />
      <Layout>
        <CompareMenu />
        <CookieConsent />
      </Layout>
    </div>
  );
}

export default App;
